/**
 * Config bắt đầu từ đây!
 * Quy định route với: Private, public, separate route ...
 */
import Vehicle from 'entities/vehicle';
import Seating from 'entities/seating';
import Journey from 'entities/journey';
import Orders from 'entities/orders';
import Ticket_managers from 'entities/ticket-managers';
import Dashboard from 'entities/dashboard/index';
import EditMyProfile from 'entities/user-profile/edit-my-profile';
import Profile from 'entities/user-profile/profile';
import ActiveAccount from '../layout/active.account';
import Login from '../layout/login';
import RecoverPassword from '../layout/recover-password';

import Customer from 'entities/customer';
import IncomingWebhook from 'entities/incoming_webhook';
import OutgoingWebhook from 'entities/outgoing_webhook';
import Media from '../entities/media';
import MediaSetting from '../entities/media_setting';
import Settings from '../entities/settings/index';
import Users from '../entities/users';

import AccountSetting from 'entities/account_setting';
import BackUp from 'entities/backup';
import Embed from 'entities/embed';
import KeyMapIndex from 'entities/keymap';
import Security from 'entities/security';
import ServerInfo from 'entities/server_info';
import Transactions from 'entities/transactions';

/**
 * Private, w/ <AppFrame />
 * Only authorization can access this route
 */

export const private_route = [
  {
    path: '/',
    Entity: Dashboard,
  },

  {
    path: '/transactions',
    Entity: Transactions,
  },

  {
    path: '/:tab',
    Entity: Dashboard,
  },

  {
    path: '/keymap',
    Entity: KeyMapIndex,
  },

  {
    path: '/profile',
    Entity: Profile,
  },

  {
    path: '/edit-my-profile',
    Entity: EditMyProfile,
  },

  {
    path: '/settings',
    Entity: Settings,
  },
  {
    path: '/account_setting',
    Entity: AccountSetting,
  },
  {
    path: '/account_setting/:slug',
    Entity: AccountSetting,
  },
  {
    path: '/media',
    Entity: Media,
  },
  {
    path: '/media/:slug/:media_slug',
    Entity: Media,
  },
  {
    path: '/media/:slug',
    Entity: Media,
  },
  {
    path: '/media_setting',
    Entity: MediaSetting,
  },
  {
    path: '/users/:slug/:users_slug',
    Entity: Users,
  },
  {
    path: '/users/:slug',
    Entity: Users,
  },
  {
    path: '/users',
    Entity: Users,
  },
  {
    path: '/vehicle',
    Entity: Vehicle,
  },
  {
    path: '/vehicle/:vehicle_id',
    Entity: Vehicle,
  },
  {
    path: '/vehicle/:vehicle_id/:mode',
    Entity: Vehicle,
  },
  {
    path: '/vehicle/:vehicle_id/:mode/:vehicle_log_id',
    Entity: Vehicle,
  },
  {
    path: '/seating',
    Entity: Seating,
  },
  {
    path: '/journey/:slug/:journey_id',
    Entity: Journey,
  },
  {
    path: '/journey/:slug',
    Entity: Journey,
  },
  {
    path: '/journey',
    Entity: Journey,
  },

  {
    path: '/orders/:slug/:order_id',
    Entity: Orders,
  },

  {
    path: '/orders/:slug',
    Entity: Orders,
  },
  {
    path: '/orders',
    Entity: Orders,
  },

  {
    path: '/ticket_managers',
    Entity: Ticket_managers,
  },
  {
    path: '/incoming_webhook',
    Entity: IncomingWebhook,
  },
  {
    path: '/incoming_webhook/:slug/:incoming_webhook_slug',
    Entity: IncomingWebhook,
  },
  {
    path: '/incoming_webhook/:slug',
    Entity: IncomingWebhook,
  },

  {
    path: '/outgoing_webhook',
    Entity: OutgoingWebhook,
  },
  {
    path: '/outgoing_webhook/:slug/:outgoing_webhook_slug',
    Entity: OutgoingWebhook,
  },
  {
    path: '/outgoing_webhook/:slug',
    Entity: OutgoingWebhook,
  },

  {
    path: '/customer',
    Entity: Customer,
  },
  {
    path: '/customer/:slug/:customer_id',
    Entity: Customer,
  },
  {
    path: '/customer/:slug',
    Entity: Customer,
  },

  {
    path: '/backup',
    Entity: BackUp,
  },

  {
    path: '/embed',
    Entity: Embed,
  },

  {
    path: '/security',
    Entity: Security,
  },

  {
    path: '/server_info',
    Entity: ServerInfo,
  },
];

/**
 * Any one can access this URL
 */
export const public_route = [];

/**
 * Run first and wihout <AppFrame>,
 * It is like login page, register page
 */

export const separate_route = [
  {
    path: '/login',
    Entity: Login,
  },

  {
    path: '/active-account',
    Entity: ActiveAccount,
  },
  {
    path: '/login/sso',
    Entity: Login,
  },
  {
    path: '/recover_password',
    Entity: RecoverPassword,
  },
];

